/**
 * Client API centralisé avec intercepteurs
 * Gère automatiquement l'authentification et les erreurs
 */
import axios from 'axios';
import config from '../config/api';

// Créer une instance axios avec la configuration de base
// Le backend utilise un cookie httpOnly `auth_token`, pas besoin de gérer le token ici
const apiClient = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 secondes
  withCredentials: true, // envoyer automatiquement les cookies (auth_token)
});

/**
 * Intercepteur de réponse : Gère les erreurs globalement
 */
apiClient.interceptors.response.use(
  (response) => {
    // Retourner la réponse telle quelle si tout va bien
    return response;
  },
  (error) => {
    // Gérer les erreurs HTTP
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 401:
          // Session expirée ou non authentifiée (cookie auth_token invalide)
          if (!window.location.pathname.startsWith('/auth')) {
            window.location.href = '/auth/sign-in';
          }
          break;
          
        case 403:
          // Accès interdit
          console.error('Accès interdit:', data?.message || 'Vous n\'avez pas les permissions nécessaires');
          break;
          
        case 404:
          // Ressource non trouvée
          console.error('Ressource non trouvée:', error.config.url);
          break;
          
        case 500:
          // Erreur serveur
          console.error('Erreur serveur:', data?.message || 'Une erreur est survenue sur le serveur');
          break;
          
        default:
          console.error('Erreur API:', status, data?.message || error.message);
      }
    } else if (error.request) {
      // La requête a été faite mais aucune réponse n'a été reçue
      console.error('Pas de réponse du serveur:', error.request);
    } else {
      // Une erreur s'est produite lors de la configuration de la requête
      console.error('Erreur de configuration:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;

